import Web3 from "web3";
import { CHANIN_NETWORK_MAP } from "@/constants/chains.js";

/**
 * 根据指定区块链地址获取provider
 *
 * @returns
 */
export const getHttpProviderByChain = (chain) => {
  const url = CHANIN_NETWORK_MAP[chain]?.rpcUrls[0];
  if (url) {
    const web3 = new Web3(url);
    return web3;
  }

  return null;
};

/**
 * 获取合约
 * Web3版本
 * @param library
 * @param abi
 * @param address
 * @returns
 */
export const getContractByWeb3 = (library, address, abi) => {
  if (!library) {
    return;
  }
  return new library.eth.Contract(abi, address);
};
